import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { RootState } from './store';
import { SystemConfiguration } from '../interfaces';
import { getSystemConfigurations } from '../api/getSystemConfigurations';

export interface SystemConfigurationsState {
    items: SystemConfiguration[] | null;
}

const initialState: SystemConfigurationsState = {
    items: null,
};

export const loadSystemConfigurations = createAsyncThunk('systemConfigurations/load', async () => {
    return await getSystemConfigurations();
});

export const SystemConfigurationsSlice = createSlice({
    name: 'systemConfigurations',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(loadSystemConfigurations.fulfilled, (state, action) => {
                state.items = action.payload;
            })
            .addCase(loadSystemConfigurations.rejected, (state, action) => {
                console.error(action.error);
            });
    },
});

export const selectSystemConfigurations = (state: RootState) => state.systemConfigurations.items;

export default SystemConfigurationsSlice.reducer;
